import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
} from 'beyond-util';
import { CenovniciComponent } from './cenovnici.component';

@NgModule({
  declarations: [CenovniciComponent],
  entryComponents: [CenovniciComponent],
  exports: [CenovniciComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    NgxSpinnerModule,
  ],
})
export class CenovniciModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/cenovnici/cenovnici.module.ts